import { getCategoryDataFromLabel } from "../helpers/zoneFilters";
import { SeatsIOSeat } from "~components/reservation/constants";
import { EventQuery } from "~graphql/sdk";
import { getPrice } from "../helpers/pricing";
import { Release } from "../types";
interface SeatPropertiesProps {
  seats: SeatsIOSeat[];
  multiBuyPromotions: EventQuery["event"]["multiBuyPromotions"];
  eventTicketTypes: EventQuery["event"]["ticketTypes"];
  releasedZones: Release["releaseZones"];
}

export const addPropertiesToSeats = ({
  seats,
  multiBuyPromotions,
  eventTicketTypes,
  releasedZones,
}: SeatPropertiesProps) => {
  const addTicketType = (seat: SeatsIOSeat, idx: number) => {
    const { zone: zoneName, section: sectionName } = getCategoryDataFromLabel(
      seat.category?.label
    );

    const releasedZone = releasedZones.find(
      ({ zone }) => zone.name === zoneName
    );

    // If seat already has aticket type then leave as is
    if (seat.ticketType) {
      return seat;
    }

    const releasedTickets = releasedZone.ticketTypes
      .filter((ticket) => {
        if (!ticket.isActive) {
          return false;
        }

        if (sectionName && ticket.sections?.length) {
          const section = ticket.sections?.find((s) => s.name === sectionName);

          return typeof section?.price === "number";
        }

        return true;
      })
      .map((ticket) => {
        return eventTicketTypes.find(
          (eventTicket) => eventTicket.id === ticket.ticketTypeId
        );
      });

    let adultTicketType = releasedTickets.find((ticketType) => {
      return ticketType.name.trim().toLowerCase() === "adult";
    });

    if (!adultTicketType) {
      adultTicketType = releasedTickets.find((ticketType) => {
        return ticketType.name.toLowerCase().includes("adult");
      });
    }

    const customId: string | undefined =
      seat.objectType === "GeneralAdmissionArea"
        ? `${seat.id}-${idx}`
        : undefined;

    // Default the selected seats to Adult ticket type
    // if exists, otherwise use the first option
    const ticketType = adultTicketType || releasedTickets[0];

    return {
      ...seat,
      customId,
      ticketType,
    };
  };

  const addPrice = (seat: SeatsIOSeat) => {
    const [price, originalPrice] = getPrice({
      seat,
      releasedZones,
    });

    return {
      ...seat,
      price,
      originalPrice,
    };
  };

  const addLocationLabel = (seat: SeatsIOSeat) => {
    const categoryLabel = seat.category?.label;

    const { zone: zoneLabel, section: sectionLabel } =
      getCategoryDataFromLabel(categoryLabel);

    return {
      ...seat,
      zoneLabel,
      sectionLabel,
    };
  };

  return seats.map(addTicketType).map(addPrice).map(addLocationLabel);
};
